import React from 'react'
import { useNavigate } from 'react-router-dom'

import "./elecheader.css"

export default function ElecHeader() {
    const navigate = useNavigate()
  return (
    <div className='emas__elecheader'>
        <div className='emas__elecheader-content'>
            <h1>Our Electricity Market Modeling is Your Solution to Simulate the WA Economy</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Suscipit adipiscing bibendum est ultricies integer quis auctor elit. Sit amet facilisis magna etiam tempor orci eu lobortis elementum.</p>
            <button onClick={() => navigate("../Contact-Us")}>Talk to an Expert</button>
        </div>
    </div>
  )
}
